import Swiper from 'swiper';
// import 'remodal';

// スクロールアニメーション（各.animを個別に判定、表示時にアニメーション発火）
const funcAnim = () => {
	// JSONから後で描画される要素も拾うため、判定のたびに取り直す
	const check = () => {
		const items = document.querySelectorAll('.anim');
		if (!items.length) return;

		const th = window.innerHeight * 0.9;
		items.forEach((el) => {
			if (el.classList.contains('active')) return;
			const r = el.getBoundingClientRect();
			if (r.top < th && r.bottom > 0) el.classList.add('active');
		});
	};

	document.readyState === 'complete' ? check() : window.addEventListener('load', check, { once: true });
	window.addEventListener('scroll', check, { passive: true });
	window.addEventListener('resize', check);
	window.addEventListener('anim:refresh', check);
};

// スムーススクロール
const HEADER_OFFSET = 71;
const easeInOut = (t) => (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1);
const duration = 500;

const scrollToTarget = (el) => {
	const targetPosition = el.getBoundingClientRect().top + (window.scrollY || 0) - HEADER_OFFSET;
	window.scrollTo(0, Math.max(0, targetPosition));
};

const run = () => {
	const triggers = document.querySelectorAll('.anchor');

	triggers.forEach((trigger) => {
		trigger.addEventListener('click', (e) => {
			const href = trigger.getAttribute('href');
			if (!href) return;

			const match = href.match(/#(.+)$/);
			const targetId = match ? match[1] : null;
			if (!targetId) return;

			const targetElement = document.getElementById(targetId);
			if (!targetElement) return;

			e.preventDefault();

			const startScroll = () => {
				const currentPosition = window.scrollY || 0;
				const targetPosition = currentPosition + targetElement.getBoundingClientRect().top - HEADER_OFFSET;
				const distance = targetPosition - currentPosition;
				const startTime = performance.now();

				const loop = (nowTime) => {
					const normalizedTime = (nowTime - startTime) / duration;
					if (normalizedTime < 1) {
						window.scrollTo(0, currentPosition + distance * easeInOut(normalizedTime));
						requestAnimationFrame(loop);
					} else {
						window.scrollTo(0, targetPosition);
					}
				};

				requestAnimationFrame(loop);
			};

			// ドロワーが開いている場合は closeNav() の完了を待ってからスクロール
			if (document.body.classList.contains('nav-open')) {
				requestAnimationFrame(() => requestAnimationFrame(startScroll));
			} else {
				startScroll();
			}
		});
	});

	// 他ページからハッシュ付きで遷移した場合のオフセット補正（70px維持）
	// スマホ実機ではブラウザのアンカースクロールが遅れるため、複数回実行
	const initHashScroll = () => {
		if (!window.location.hash) return;
		const targetElement = document.getElementById(window.location.hash.slice(1));
		if (!targetElement) return;
		scrollToTarget(targetElement);
	};
	initHashScroll();
	window.addEventListener('load', initHashScroll);
	[100, 300, 600].forEach((delay) => setTimeout(initHashScroll, delay));

	// スライダー SPのみ（559px未満）
	const slides = document.querySelectorAll('.news .slide');
	const mqSp = window.matchMedia('(max-width: 559px)');

	slides.forEach((slideEl) => {
		let swiper = null;

		const syncSwiper = () => {
			if (mqSp.matches) {
				const container = slideEl.querySelector('.swiper-container');
				if (container) {
					swiper = new Swiper(container, {
						loop: true,
						spaceBetween: 20,
						slidesPerView: 1.6,
						speed: 400,
						// navigation: {
						// 	nextEl: slideEl.querySelector('.swiper-button-next'),
						// 	prevEl: slideEl.querySelector('.swiper-button-prev'),
						// },
					});
				}
			} else if (swiper) {
				swiper.destroy(false, true);
				swiper = null;
			}
		};

		mqSp.addEventListener('change', syncSwiper);
		syncSwiper();
	});

	// 高橋愛コラボ スライダー（bottle holder / LOOK02）
	window.addEventListener('load', function () {
		document.querySelectorAll('.ai-takahashi__slider').forEach(function (root) {
			const container = root.querySelector('.swiper-container');
			if (!container) return;
			const hasMultiple = container.querySelectorAll('.swiper-slide').length > 1;
			// スライド間のアキはデザイン実測をスライド幅比で持つ（画面幅に追従させるため）
			const gapRatio = parseFloat(root.dataset.gap) || 0;
			new Swiper(container, {
				loop: hasMultiple,
				spaceBetween: container.offsetWidth * gapRatio,
				speed: 600,
				observer: true,
				observeParents: true,
				autoplay: hasMultiple ? { delay: 3500, disableOnInteraction: false } : false,
			});
		});
	});

	// 商品スライダー（goods.html）
	window.addEventListener('load', function () {
		const goodsSliders = document.querySelectorAll('.goods__slider');
		goodsSliders.forEach(function (root) {
			const container = root.querySelector('.swiper-container');
			if (!container) return;
			const slideCount = container.querySelectorAll('.swiper-slide').length;
			const hasMultiple = slideCount > 1;
			const options = {
				loop: hasMultiple,
				spaceBetween: 0,
				speed: 600,
				autoplay: hasMultiple
					? { delay: 3500, disableOnInteraction: false }
					: false,
			};
			if (hasMultiple) {
				options.navigation = {
					nextEl: root.querySelector('.swiper-button-next'),
					prevEl: root.querySelector('.swiper-button-prev'),
				};
			}
			new Swiper(container, options);
		});

		// goods フィルター: ALL / 高知 / 熊本 / 北海道 / 静岡
		const filterBtns = document.querySelectorAll('.goods__filter-btn');
		const allThumbs = document.querySelectorAll('.goods__thumb:not(.goods__thumb--regular)');

		const applyFilter = function (filterValue) {
			filterBtns.forEach(function (btn) {
				btn.classList.toggle('active', btn.dataset.filter === filterValue);
			});
			allThumbs.forEach(function (thumb) {
				if (filterValue === 'all') {
					thumb.classList.remove('is-dimmed');
				} else {
					thumb.classList.toggle('is-dimmed', thumb.dataset.filter !== filterValue);
				}
			});
		};

		const handleHash = function () {
			const hash = window.location.hash.slice(1);
			const valid = ['all', 'kouchi', 'kumamoto', 'hokkaido', 'shizuoka'];
			applyFilter(valid.indexOf(hash) !== -1 ? hash : 'all');
		};

		filterBtns.forEach(function (btn) {
			btn.addEventListener('click', function (e) {
				e.preventDefault();
				const filter = btn.dataset.filter;
				if (history.pushState) {
					history.pushState(null, '', '#' + filter);
				} else {
					window.location.hash = filter;
				}
				applyFilter(filter);
			});
		});

		window.addEventListener('hashchange', handleHash);
		handleHash();

		// goods フィルターボタン: hero内の元位置を超えたら ヘッダー下に固定
		const filterEl = document.querySelector('.goods__filter');
		if (filterEl) {
			const HEADER_H = 71;
			let triggerY = 0;
			const initTrigger = function () {
				filterEl.classList.remove('is-fixed');
				const rect = filterEl.getBoundingClientRect();
				triggerY = rect.top + window.scrollY - HEADER_H;
			};
			const handleFilterFix = function () {
				filterEl.classList.toggle('is-fixed', window.scrollY > triggerY);
			};
			initTrigger();
			window.addEventListener('scroll', handleFilterFix, { passive: true });
			window.addEventListener('resize', function () {
				initTrigger();
				handleFilterFix();
			});
		}
	});

	// アイテムスライダー（常時・PC/SP共通）
	window.addEventListener('load', function () {
		const itemSliders = document.querySelectorAll('.oshilep__items-slider');
		for (let i = 0; i < itemSliders.length; i++) {
			const root = itemSliders[i];
			const container = root.querySelector('.swiper-container');
			if (!container) continue;
			const slideCount = container.querySelectorAll('.swiper-slide').length;
			const hasMultiple = slideCount > 1;
			if (!hasMultiple) {
				root.classList.add('oshilep__items-slider--single');
			}
			const options = {
				loop: hasMultiple,
				spaceBetween: 0,
				speed: 600,
				autoplay: hasMultiple
					? {
							delay: 3000,
							disableOnInteraction: false,
						}
					: false,
			};
			if (hasMultiple) {
				options.navigation = {
					nextEl: root.querySelector('.swiper-button-next'),
					prevEl: root.querySelector('.swiper-button-prev'),
				};
			}
			new Swiper(container, options);
		}
	});

	// ニュース詳細ギャラリースライダー（#single .single__gallery）
	window.addEventListener('load', function () {
		const galleries = document.querySelectorAll('.single__gallery');
		galleries.forEach(function (root) {
			const container = root.querySelector('.swiper-container');
			if (!container) return;
			new Swiper(container, {
				loop: true,
				slidesPerView: 1,
				speed: 500,
				autoplay: { delay: 3500, disableOnInteraction: false },
				navigation: {
					nextEl: root.querySelector('.swiper-button-next'),
					prevEl: root.querySelector('.swiper-button-prev'),
				},
			});
		});
	});

	// スクロールでヘッダーに active クラスを付与＋下スクロールで隠す（PCのみ）
	const HEADER_SCROLL_THRESHOLD = 400;
	const HEADER_HIDE_FROM = 500; // ここを超えてから隠し始める
	const HEADER_HIDE_DELTA = 12; // この量より小さいスクロールでは反応しない
	const header = document.querySelector('header');
	if (header) {
		let lastScroll = window.scrollY || window.pageYOffset;

		window.addEventListener(
			'scroll',
			() => {
				const scrollTop = window.scrollY || window.pageYOffset;
				header.classList.toggle('active', scrollTop > HEADER_SCROLL_THRESHOLD);

				// ドロワー展開中は隠さない（中の .nav-container が fixed のため transform を掛けられない）
				if (document.body.classList.contains('nav-open')) {
					header.classList.remove('is-hidden');
					lastScroll = scrollTop;
					return;
				}
				if (Math.abs(scrollTop - lastScroll) < HEADER_HIDE_DELTA) return;

				if (scrollTop > lastScroll && scrollTop > HEADER_HIDE_FROM) {
					header.classList.add('is-hidden');
				} else if (scrollTop < lastScroll) {
					header.classList.remove('is-hidden');
				}
				lastScroll = scrollTop;
			},
			{ passive: true }
		);
	}

	// スクロールアニメーション
	funcAnim();
};

window.addEventListener('DOMContentLoaded', run);

// Maruche Gallery Modal
(function () {
	const galleryItems = document.querySelectorAll('.maruche__gallery-item');
	const modal = document.getElementById('js-maruche-modal');
	if (!galleryItems.length || !modal) return;

	const overlay = modal.querySelector('.maruche-modal__overlay');
	const closeBtn = modal.querySelector('.maruche-modal__close');
	const prevBtn = modal.querySelector('.maruche-modal__prev');
	const nextBtn = modal.querySelector('.maruche-modal__next');
	const swiperEl = document.getElementById('js-gallery-modal-swiper');
	const container = modal.querySelector('.maruche-modal__container');
	const mqSp = window.matchMedia('(max-width: 767px)');
	let gallerySwiper = null;
	let arrowTimer = null;

	const fitContainerToImage = (index) => {
		if (mqSp.matches) return;
		const slides = swiperEl.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
		const idx = index !== undefined ? index : (gallerySwiper ? gallerySwiper.realIndex : 0);
		const img = slides[idx]?.querySelector('img');
		if (!img || !img.naturalWidth || !img.naturalHeight) return;
		const maxH = window.innerHeight * 0.9;
		const ratio = img.naturalWidth / img.naturalHeight;
		const w = Math.min(Math.round(maxH * ratio), window.innerWidth);
		container.style.width = w + 'px';
		requestAnimationFrame(() => { if (gallerySwiper) gallerySwiper.update(); });
	};

	const showArrows = () => {
		prevBtn.classList.remove('is-hidden');
		nextBtn.classList.remove('is-hidden');
	};

	const hideArrowsTemporarily = () => {
		if (!mqSp.matches) return;
		prevBtn.classList.add('is-hidden');
		nextBtn.classList.add('is-hidden');
		clearTimeout(arrowTimer);
		arrowTimer = setTimeout(showArrows, 2000);
	};

	const openModal = (index) => {
		const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
		document.body.style.overflow = 'hidden';
		document.body.style.paddingRight = scrollbarWidth + 'px';
		modal.classList.add('is-open');
		modal.setAttribute('aria-hidden', 'false');
		fitContainerToImage(index);
		void swiperEl.offsetWidth;

		if (!gallerySwiper) {
			gallerySwiper = new Swiper(swiperEl, {
				loop: true,
				slidesPerView: 1,
				spaceBetween: 0,
				speed: 400,
				navigation: {
					nextEl: nextBtn,
					prevEl: prevBtn,
				},
				on: {
					slideChange: hideArrowsTemporarily,
					transitionEnd: fitContainerToImage,
				},
			});
		} else {
			gallerySwiper.update();
		}
		gallerySwiper.slideToLoop(index, 0);
		showArrows();
	};

	const closeModal = () => {
		modal.classList.remove('is-open');
		modal.setAttribute('aria-hidden', 'true');
		document.body.style.overflow = '';
		document.body.style.paddingRight = '';
		container.style.width = '';
	};

	galleryItems.forEach((item) => {
		item.addEventListener('click', () => openModal(Number(item.dataset.index)));
	});

	overlay.addEventListener('click', closeModal);
	closeBtn.addEventListener('click', closeModal);
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') closeModal();
	});
	window.addEventListener('resize', () => {
		if (!modal.classList.contains('is-open')) return;
		fitContainerToImage();
	});
})();

// 動画の再生をGAで計測（data-ga にイベント名を書いた video が対象。simple_is は simple_is.js 側で計測済み）
document.querySelectorAll('video[data-ga]').forEach((video) => {
	video.addEventListener('play', () => {
		if (typeof gtag === 'function') gtag('event', video.dataset.ga);
	});
});

// 高橋愛コラボ MOVIE の再生UI（simple_is と同方式。PCは独自ボタン、タッチ機は標準UI＋全画面）
(() => {
	const wrap = document.querySelector('.ai-takahashi__movie-box');
	if (!wrap) return;

	const video = wrap.querySelector('video');
	const playBtn = wrap.querySelector('.ai-takahashi__movie-play');
	const isTouch = window.matchMedia('(hover: none) and (pointer: coarse)').matches;

	if (isTouch) {
		// 独自ボタンはDOMごと外して二重タップを防ぐ
		playBtn?.remove();
		// iOS: playsinline を外すと再生時に自動で全画面になる
		video.removeAttribute('playsinline');
	} else {
		playBtn?.addEventListener('click', () => video.play());
	}

	// 右クリック（長押し）の「動画を保存」を抑止
	video.addEventListener('contextmenu', (e) => e.preventDefault());

	video.addEventListener('play', () => {
		// Android: 全画面にする（iOSは playsinline を外してあるので自動で全画面になる）
		if (isTouch && video.requestFullscreen) video.requestFullscreen().catch(() => {});
		wrap.classList.add('is-playing');
	});
	video.addEventListener('pause', () => wrap.classList.remove('is-playing'));
	video.addEventListener('ended', () => wrap.classList.remove('is-playing'));
})();

// Tour Gallery Modal（kochi / nara 共通。ページに該当要素が無ければ何もしない）
const initTourGalleryModal = ({ itemSelector, modalId, swiperId, modalClass }) => {
	const galleryItems = document.querySelectorAll(itemSelector);
	const modal = document.getElementById(modalId);
	if (!galleryItems.length || !modal) return;

	const overlay = modal.querySelector(`.${modalClass}__overlay`);
	const closeBtn = modal.querySelector(`.${modalClass}__close`);
	const prevBtn = modal.querySelector(`.${modalClass}__prev`);
	const nextBtn = modal.querySelector(`.${modalClass}__next`);
	const swiperEl = document.getElementById(swiperId);
	const container = modal.querySelector(`.${modalClass}__container`);
	const mqSp = window.matchMedia('(max-width: 767px)');
	let gallerySwiper = null;
	let arrowTimer = null;

	const fitContainerToImage = (index) => {
		if (mqSp.matches) return;
		const slides = swiperEl.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
		const idx = index !== undefined ? index : (gallerySwiper ? gallerySwiper.realIndex : 0);
		const img = slides[idx]?.querySelector('img');
		if (!img || !img.naturalWidth || !img.naturalHeight) return;
		const maxH = window.innerHeight * 0.9;
		const ratio = img.naturalWidth / img.naturalHeight;
		const w = Math.min(Math.round(maxH * ratio), window.innerWidth);
		container.style.width = w + 'px';
		requestAnimationFrame(() => { if (gallerySwiper) gallerySwiper.update(); });
	};

	const showArrows = () => {
		prevBtn.classList.remove('is-hidden');
		nextBtn.classList.remove('is-hidden');
	};

	const hideArrowsTemporarily = () => {
		if (!mqSp.matches) return;
		prevBtn.classList.add('is-hidden');
		nextBtn.classList.add('is-hidden');
		clearTimeout(arrowTimer);
		arrowTimer = setTimeout(showArrows, 2000);
	};

	const openModal = (index) => {
		const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
		document.body.style.overflow = 'hidden';
		document.body.style.paddingRight = scrollbarWidth + 'px';
		modal.classList.add('is-open');
		modal.setAttribute('aria-hidden', 'false');
		fitContainerToImage(index);
		void swiperEl.offsetWidth;

		if (!gallerySwiper) {
			gallerySwiper = new Swiper(swiperEl, {
				loop: true,
				slidesPerView: 1,
				spaceBetween: 0,
				speed: 400,
				navigation: {
					nextEl: nextBtn,
					prevEl: prevBtn,
				},
				on: {
					slideChange: hideArrowsTemporarily,
					transitionEnd: fitContainerToImage,
				},
			});
		} else {
			gallerySwiper.update();
		}
		gallerySwiper.slideToLoop(index, 0);
		showArrows();
	};

	const closeModal = () => {
		modal.classList.remove('is-open');
		modal.setAttribute('aria-hidden', 'true');
		document.body.style.overflow = '';
		document.body.style.paddingRight = '';
		container.style.width = '';
	};

	galleryItems.forEach((item) => {
		item.addEventListener('click', () => openModal(Number(item.dataset.index)));
	});

	overlay.addEventListener('click', closeModal);
	closeBtn.addEventListener('click', closeModal);
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') closeModal();
	});
	window.addEventListener('resize', () => {
		if (!modal.classList.contains('is-open')) return;
		fitContainerToImage();
	});
};

initTourGalleryModal({
	itemSelector: '.kochi__gallery-item',
	modalId: 'js-kochi-modal',
	swiperId: 'js-kochi-gallery-swiper',
	modalClass: 'kochi-modal',
});

initTourGalleryModal({
	itemSelector: '.nara__gallery-item',
	modalId: 'js-nara-modal',
	swiperId: 'js-nara-gallery-swiper',
	modalClass: 'nara-modal',
});

// ----------------------------------------------------
//	高橋愛コラボ STAFF BOARD（ハッシュタグ投稿）
//	simple_is.js と同じ sb-style / coordinate API。Vue2 + axios は HTML の <head> で CDN 読み込み
// ----------------------------------------------------
// ▼公開時はここだけ差し替える
var AI_TAKAHASHI_TAG = '高橋愛さん_LEPSIM';
// 投稿がまだ0件の間、ローカル／ステージングでだけ表示確認に使うタグ。本番では使わない
var AI_TAKAHASHI_PREVIEW_TAG = 'Simple is…_LEPSIM';
// ----------------------------------------------------
var AI_TAKAHASHI_LABEL = '0000000028'; // LEPSIM のブランドID
var AI_TAKAHASHI_COUNT = 8; // カンプが4列×2行のため8件
var AI_TAKAHASHI_API = 'https://sb-api.dot-st.com/jp/ja/v1/coordinate?merchant_id=75d19a0d30140e4e3109f8a29f61214c';

const aiTakahashiStyleUrl = (tag) =>
	AI_TAKAHASHI_API + '&count=' + AI_TAKAHASHI_COUNT + '&tag=' + encodeURIComponent(tag) + '&label=' + AI_TAKAHASHI_LABEL;

if (document.getElementById('staff-section') && typeof Vue !== 'undefined' && typeof axios !== 'undefined') {
	new Vue({
		el: '#staff-section',
		data: {
			items: [],
			tag_label: '＃' + AI_TAKAHASHI_TAG,
			more_href:
				'https://www.dot-st.com/cp/sb-style/?tag=' + encodeURIComponent(AI_TAKAHASHI_TAG) + '&label=' + AI_TAKAHASHI_LABEL,
		},
		mounted: function () {
			const self = this;
			// 本番ドメイン以外でのみ、0件のときプレビュー用タグに切り替える（レイアウト確認のため）
			const isPreview = /\.local$|special-web\.site$/.test(location.hostname);
			axios
				.get(aiTakahashiStyleUrl(AI_TAKAHASHI_TAG))
				.then(function (response) {
					const items = (response.data && response.data.item) || [];
					if (items.length || !isPreview) {
						self.items = items;
						return null;
					}
					return axios.get(aiTakahashiStyleUrl(AI_TAKAHASHI_PREVIEW_TAG)).then(function (preview) {
						self.items = (preview.data && preview.data.item) || [];
						console.info('[ai_takahashi] 投稿0件のためプレビュー用タグで表示しています');
					});
				})
				.catch(function (err) {
					console.warn('ai_takahashi staff board load failed:', err);
				});
		},
	});
}
